import React from "react";

const Subtitle1 = ({ content }) => {
  return (
    <div className="articleRender-container subtitle1Block">{content.text}</div>
  );
};

export default Subtitle1;
